export const getRedesignThemeTokens = (dark) => ({
  '--app-surface': dark ? '#171c24' : '#ffffff',
  '--app-surface-subtle': dark ? '#1d232d' : '#fafbfc',
  '--app-surface-rail': dark ? '#151a22' : '#fcfcfd',
  '--app-border': dark ? '#303844' : '#eef0f3',
  '--app-divider': dark ? '#2a323d' : '#f0f1f4',
  '--app-text': dark ? '#edf2f7' : '#252F40',
  '--app-text-secondary': dark ? '#aab4c3' : '#67748E',
  '--app-muted': dark ? '#7f8a9a' : '#a2a9b4',
  '--app-selected': dark ? 'rgba(1,168,248,0.16)' : '#eef6fe',
  '--app-hover': dark ? 'rgba(255,255,255,0.06)' : '#f2f5f9',
  '--app-info-surface': dark ? 'rgba(1,168,248,0.10)' : '#f4f9fe',
  '--app-info-border': dark ? 'rgba(1,168,248,0.30)' : '#e2eefb',
  '--app-warning-surface': dark ? 'rgba(224,163,37,0.12)' : '#fffbec',
  '--app-warning-border': dark ? 'rgba(224,163,37,0.42)' : '#f6d46f',
});
